










import { Vue, Component } from 'vue-property-decorator';
import EstructuraComercial from './EstructuraComercial.vue';

@Component({ components: { EstructuraComercial } })
export default class EstructuraComercialPantalla extends Vue {}
